import React, { Component,useMemo, useEffect, useState } from 'react';
import { Helper } from '../../../src/ToolKit/toolkit.js';

import $ from 'jquery/dist/jquery';
import { Menu, ColumnType, Action, AlertD, YesNo, DropDownBox, SelectBasic, DayTimeSelector, FormDiv, InputBox, Icon, SideView, SideItem, FilterView, SpecValues, ProTable, SimpleButton, CustomHelper, FixedMessage, Captia, Column, NewRecordValue, FromBasic, AddButton, FileProgess, LoadingBar, FromSubmit, InputTextBox, InputPasswordBox, Model, Confirm, RowState, ShowFixedPage } from '../.././Componet';
import { useParams, useNavigate } from "react-router-dom";
import { Route, Link } from "react-router-dom";
import { Modal } from 'bootstrap';
import { DataClass, enums } from '../../../src/ToolKit/DataClass.js'
import { data, param } from 'jquery';
import { SerailBySerail } from '../ProductService/Pages.jsx';

function AjaxStatus(props) {
    return <div id='AjaxStatus' style={{ position: 'fixed', left: '0px', bottom: '0px', display: 'none' }}>
        <LoadingBar /> {FixedMessage.PleaseWait}
    </div>

}
function SmsReportForMe() {


    const [pageState, setData] = useState({ records: [], isLoaded: false, grouped: [], filter: '', pageTemplate: [], templateId: -1 });


    const serach = () => {
        let h = new Helper();

        h.SaveState();
        h.Validate();
        if (h.isValidate() == false) {

            return;
        }
        let data = h.GetPostData();
        h.Ajax('ClientHub', 'SerachMyMessages', data, (data) => {
            setData({ records: data, isLoaded: true, filter: '', grouped: pageState.grouped, pageTemplate: pageState.pageTemplate, templateId: pageState.templateId });

        });
    };

 






    return <FromBasic>




       
        <InputTextBox caption="از تاریخ" columnName="start" mustFill="yes" model="start" size="50%" customHelper={CustomHelper.isDate}></InputTextBox>
        <InputTextBox caption="تا تاریخ" columnName="end" mustFill="yes" model="end" size="50%" customHelper={CustomHelper.isDate}></InputTextBox>
        <center>
        </center>


        <center>
            <SimpleButton onClick={serach} title="جست و جو " Icon="View"></SimpleButton>

        </center>

        {pageState.isLoaded &&
            <ProTable rowNumbering={true} datasourcename="records" key={Date().toString()} Records={pageState.records}>
                <Column metaForDisplay={DataClass.SmsReport.CreateTime} />
                <Column metaForDisplay={DataClass.SmsReport.Mobile} />
                <Column metaForDisplay={DataClass.SmsReport.Context} />
                <Column metaForDisplay={DataClass.SmsReport.ApplicationTitle} />
                <Column metaForDisplay={DataClass.SmsReport.Result} />
       
            </ProTable>


        }

    </FromBasic>

}


function MyOrders() {





    let status = useParams().status;
    const [pageState, orders] = useState({ orders: [], isLoaded: false, filter: '', pageTemplate: [], templateId: -1 });
 

    const serach = () => {
        let h = new Helper();
        h.SaveState();
        let data = h.GetPostData();
        h.Ajax('ClientHub', 'MyOrders', data, (data) => {
            orders({ orders: data, isLoaded: true, filter: '', pageTemplate: pageState.pageTemplate, templateId: pageState.templateId });

        });
    };
    


 

     
    

    const Print = (record) => {
        window.open('/sf/' + record.id );

    }
    const StartPay = (record) => {
        window.open('/po/' + record.id );

    }
    const GetDelevryInfo = (record) => {
        let h = new Helper();
        h.Ajax('ClientHub', 'GetOrderStatus', { id: record.id }, (data) => {
            h.MessageBox(('زمان :' + data.order.deleryTime + '<br/>' +
                'وضعیت :' + h.GetCaptionFromEnum(enums.DeleryStatus, data.order.deleryStatus) + '<br/>'
                + 'کد مرسوله :' + data.order.postCode + '<br/>'
                + 'کد اعمال محصول :' + data.order.code + '<br/>'
                + 'نحوه تحویل :' + h.GetCaptionFromEnum(enums.DelveryMethod, data.order.delveryMethod) + '<br/>'
                + 'تحویل گیرنده :' + data.order.delveryPerson + '<br/>'
            ).replace(/null/g,''), '')
        });
    };


   
    

    
 

     

   
 


    return <FromBasic>
        <form className="row g-3" id="serachBar"  >
               <InputTextBox caption="از تاریخ" columnName="StartDate" model="StartDate" size="33%" customHelper={CustomHelper.isDate}></InputTextBox>
            <InputTextBox caption="تا تاریخ" columnName="EndDate" model="EndDate" size="33%" customHelper={CustomHelper.isDate}></InputTextBox>
            <SelectBasic caption="وضعیت مالی" columnName="PayStatus" model="payStatus" includeAll={true} source={enums.PayStatus} size="33%" ></SelectBasic>
            <center>
                <SimpleButton onClick={serach} title="جست و جو " Icon="View"></SimpleButton>
            </center>
        </form>
      
     
        {pageState.isLoaded &&
            <ProTable rowNumbering={true} datasourcename="Orders" key={Date().toString()} Records={pageState.orders}>
         
                <Column metaForDisplay={DataClass.OrderSerachReport.OrderDate} />
                <Column metaForDisplay={DataClass.OrderSerachReport.TotalFactor} />
               
                <Column metaForDisplay={DataClass.OrderSerachReport.PayStatus} />

                <Column metaForDisplay={DataClass.OrderSerachReport.PayAmount} />
           
                <Column metaForDisplay={DataClass.OrderSerachReport.FactorState} />
                <Action caption="نسخه چاپی" Icon="Print" type="function" targetFun={Print} />
                <Action caption="پرداخت الکترونیک" Icon="Cash" type="function" targetFun={StartPay} />
                <Action caption="اطلاعات تحویل" Icon="Products" type="function" targetFun={GetDelevryInfo} />


            </ProTable>


        }

    </FromBasic>

}

function MyTransactions() {


    const [pageState, setData] = useState({ records: [], isLoaded: false, filter: '', pageTemplate: [], templateId: -1 });


    const serach = () => {
        let h = new Helper();
        h.SaveState();
        let data = h.GetPostData();
        h.Ajax('ClientHub', 'GetMyTransactions', data, (data) => {
            setData({ records: data, isLoaded: true, filter: '', pageTemplate: pageState.pageTemplate, templateId: pageState.templateId });

        });
    };



    return <FromBasic>


          <InputTextBox caption="از مبلغ" columnName="startAmount" model="startAmount" size="25%" customHelper={CustomHelper.isDigitngGroupedNumber}></InputTextBox>
        <InputTextBox caption="تا مبلغ" columnName="endAmount" model="endAmount" size="25%" customHelper={CustomHelper.isDigitngGroupedNumber}></InputTextBox>

        <InputTextBox caption="از تاریخ" columnName="StartDate" model="StartDate" size="25%" customHelper={CustomHelper.isDate}></InputTextBox>
        <InputTextBox caption="تا تاریخ" columnName="EndDate" model="EndDate" size="25%" customHelper={CustomHelper.isDate}></InputTextBox>
          <center>
            <SimpleButton onClick={serach} title="جست و جو " Icon="View"></SimpleButton>
        </center>

        {pageState.isLoaded &&
            <ProTable rowNumbering={true} datasourcename="records" key={Date().toString()} Records={pageState.records}>
                <Column metaForDisplay={DataClass.PaymentRef.PaymentRefId} />
                <Column metaForDisplay={DataClass.PaymentRef.ERefId} />
                <Column metaForDisplay={DataClass.PaymentRef.ObjectType} />
                <Column metaForDisplay={DataClass.PaymentRef.ObjectId} />
                <Column metaForDisplay={DataClass.PaymentRef.Amount} />
                <Column metaForDisplay={DataClass.PaymentRef.FullName} />
                <Column metaForDisplay={DataClass.PaymentRef.Mobile} />
                <Column metaForDisplay={DataClass.PaymentRef.Descr} />

                <Column metaForDisplay={DataClass.PaymentRef.CreateTime} />
                <Column metaForDisplay={DataClass.PaymentRef.SelfRefId} />
                <Column metaForDisplay={DataClass.PaymentRef.PaymentStatus} />
                <Column metaForDisplay={DataClass.PaymentRef.CardNo} />



            </ProTable>


        }

    </FromBasic>

}



export function RegUser(props) {
    const mode = { InputMobile: 0, InputCode: 1 };
    const [pageState, loadState] = useState({ mode: mode.InputMobile,mobile:'' });
    const startLogin = () => {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == true) {
            h.Ajax('Home', 'LoginByMob', { mobileId: $('#txtMobileNo').val(), dontCreateUser:true }
                , (data) => {
                    if (data.status == 200) {

                        loadState({ mobile: $('#txtMobileNo').val(), mode: mode.InputCode });
                    }
                    h.Error(data.message);
                }

            );
        }

    };
    const sendCode = () => {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == true) {
            h.Ajax('Home', 'LoginByPhone', { mobileNo: pageState.mobile, dynamicPassCode: $('#txtVerfiyCode').val() }
                , (data) => {
                    if (data.status == 200) {
                   
                      
                    }
                    if (data.token != "") {
                        localStorage.setItem('token', data.token);
                        window.location = "/Login";
                    }
                    else {
                        h.Error(data.message);
                    }
                   
                }

            );
        }


    };
    const Containr=(props = { title: '' }) => {
        return <div style={{ color: 'black' }}>

            <div style={{ position: 'fixed', color: 'black', background: 'url(/backgrounds/Bk.jpg)', backgroundSize: 'cover', left: '0px', top: '0px', zIndex: '-10', bottom: '0px', right: '0px' }} />
            <center>
                <div className="container">
                    <div className="row" style={{ padding: '25px' }}>
                        <center>
                            <div className="col-sm-3" style={{ backdropFilter: 'blur(5px)', fontSize: 'small', minWidth: '300px', position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', background: '#ffffff57', borderRadius: '5px', boxShadow: '1px 1px 3px black' }} role="alert">

                                <FromBasic staticTitle={props.title} >
                                    {props.children}
                                </FromBasic>                   <Link to="/" id="Startup" ></Link>
                                <Link to="/Admin/Index.html" id="AdminPage" ></Link>
                                طراحی و اجرا :پرویز بازگشا
                            </div>
                        </center>
                    </div>
                </div>




            </center>
            <Model />
            <Confirm />
            <AjaxStatus />
        </div>;

    }
    if (pageState.mode == mode.InputMobile) {
        return <Containr title="ثبت نام کاربر جدید">
            <ShowFixedPage id={"ثبت نام اینترنتی"} />
            <InputBox meta={DataClass.User.MobileNo} size="100%" />
            <center>
                <SimpleButton title="ارسال پیامک" onClick={startLogin } ></SimpleButton>
                <Link to="/Login" ><SimpleButton title="بازگشت"> </SimpleButton></Link>
            </center>
        </Containr>
    }
    if (pageState.mode == mode.InputCode) {
        return <Containr title="ثبت نام کاربر جدید">
            <InputBox meta={DataClass.MobileVerify.VerfiyCode} size="100%" />
            <center>
                <SimpleButton title="ورود" onClick={sendCode} ></SimpleButton>
                <SimpleButton title="تغییر شماره" onClick={() => {
                    loadState({ mobile: '', mode: mode.InputMobile });
                }} > </SimpleButton> 
            </center>
        </Containr>;
    }
    return <span>sad</span>;
}

export function Profile(props) {

    const [pageState, loadState] = useState({ isLoaded: false });
    const submit=()=>
    {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == true) {
            h.Ajax('ClientHub', 'SetProfile', h.GetPostData(),
                (data) => {
                    if (data.status == '200') {
                        h.GoBack();
                    }
                    h.MessageBox(data.message);
                }

            )
        }
    }
    const load = () => {
        let h = new Helper();
        h.Ajax('ClientHub', 'GetProfile', h.GetPostData(),
            (data) => {
                loadState({ isLoaded: true });
                h.SetDataBack(data);
            }

        )

    };
    if (pageState.isLoaded == false) {

        load();
        
    }

    return <FromSubmit submitBev={submit}>
    دقت نمائید نام و نام خانوادگی و کد ملی فقط یکبار قابل درج می باشد  
        <InputTextBox columnName="Name" caption="نام و نام خانوادگی" mustFill="yes" initvalue="name" model="Name" size="100%" />
        <InputBox meta={DataClass.Customer.NatCode} mustFill="yes" />
        <InputBox meta={DataClass.Customer.Address} mustFill="yes" />
        <InputBox meta={DataClass.Customer.PostCode} />
        <InputBox meta={DataClass.Customer.CityId} />
        <InputBox meta={DataClass.User.sex} />
    </FromSubmit>;

}

 
 

// ---------- دیتای نمونه ----------
 
const ProductList = (props) => {
    const [search, setSearch] = useState('');
    const [category, setCategory] = useState('');
    const [order, setOrder] = useState('newest');
    const [page, setPage] = useState(1);
    const [item, setItem] = useState({ products: [],totalCount:0 });
    const [categroy, setCateGory] = useState({ categroys: [] });
    const [fristLoad, fristLoadState] = useState({ loaded: false });
    // فعال‌سازی Select2 روی select دسته‌بندی
    useEffect(() => {
        $('#categorySelect').select2({
            placeholder: 'انتخاب دسته‌بندی…',
            allowClear: false,
            dir: 'rtl',
        }).on('change', (e) => {
            getLoad(1);
        });
        return () => $('#categorySelect').select2('destroy');
    }, []);

    // فیلتر + مرتب‌سازی
    const filtered = item.products;

    const totalPages = Math.ceil(item.totalCount / 8);
    const pageItems = item.products;

    // ----- فرمت قیمت -----
    const fmtPrice = n => n.toLocaleString('fa-IR') + ' ریال';

    const getLoad=(currentPage)=>
    {
        let h = new Helper();
        var data = h.GetPostData();
        data.currentPage = currentPage;
        h.Ajax('ClientHub', 'ProductSerach', data, (result) => {
            setItem({ products: result.items, totalCount: result.totalRecords });
            setPage(currentPage);
            loadCate();
        });
        

    }

    if (fristLoad.loaded == false) {
        getLoad(1);
         
        fristLoadState({ loaded: true });
       
        
    }
    const addToCart = (productId) => {
        if (props.anymos != undefined) {
            window.location = "/Admin/Shop";
        }
        let h = new Helper();
        h.Ajax('ClientHub', 'AddToCart', { productId: productId }, (data) => {
            h.Alert(data.message);
            getLoad(1);
        });
    }
    const loadCate = () => {
        let h = new Helper();
        h.Ajax('ClientHub', 'GetCategorys', {}, (result) => {
            setCateGory({ categroys: result });
        });

    };
    return (
        <form className="container-fluid py-4" dir="rtl">

            {/* ===== ردیف ۱: جستجو ===== */}
            <div className="row mb-3">
                <div className="col-12">
                    <div className="input-group input-group-lg shadow-sm">
                        <span className="input-group-text bg-white border-0">
                            <i className="bi bi-search"></i>  
                        </span>
                        <input model="title"
                            type="text"
                            className="form-control border-0"
                            placeholder="به دنبال چه می‌گردی؟"
                            
                            onKeyUp={e => { getLoad(1);  }}
                        />
                    </div>
                </div>
            </div>

            {/* ===== ردیف ۲: دسته‌بندی + ترتیب ===== */}
            <div className="row mb-4">
                {/* نصف سطر: دسته‌بندی (Select2) */}
                <div className="col-md-6 mb-2 mb-md-0">
                    <select onChange={() => {   getLoad(1); }} model="category" id="categorySelect" className="form-select">
                        <option value=""></option>
                        {categroy.categroys.map(c => <option key={c} value={c.id}>{c.name}</option>)}
                    </select>
                </div>
                {/* نصف سطر: ترتیب */}
                <div className="col-md-6">
                    <select
                        className="form-select"
                         model="order"
                        onChange={e => getLoad(1)}
                    >
                   
                        <option value="newest">جدیدترین</option>
                        <option value="oldest">جدیدترین</option>
                        <option value="cheapest">ارزان‌ترین</option>
                        <option value="expensive">گران‌ترین</option>
                    </select>
                </div>
            </div>

            {/* ===== ردیف محصولات: هر ردیف ۴ تا ===== */}
            <div className="row g-3">
                {pageItems.map(p => (
                    <div className="col-sm-6 col-lg-3" key={p.id}>
                        <div className="card h-100 shadow-sm border-0 product-card">
                            <img
                                src={'/thm/product_' + p.productId +".jpg"}
                                className="card-img-top"
                                alt={p.title}
                                style={{ objectFit: 'contain', height: 180 }}
                            />
                            <div className="card-body d-flex flex-column">
                                <h6 className="card-title text-truncate mb-2">{p.productName}</h6>
                                <p className="text-muted small mb-1">{p.cateGroyName}</p>
                                <div className="fw-bold text-primary mb-3">
                                    {p.haveGranty == true && <span style={{ borderRadius: '5px', position: 'absolute', right: '0px', top: '0px', padding: '10px', margin: '5px', background: 'linear-gradient(gold,#a1a704)', fontWeight: 'normal', boxShadow: '#ffd7004a 1px 1px 5px', color: 'white' }}>12 ماه ضمانت</span>}


                                    {p.discount == 0 && <span> {fmtPrice(p.price)} </span>}
                                    {p.discount != 0 && <span><span style={{ textDecoration: 'line-through', color: 'black' }}> {fmtPrice(p.price)}
                                     
                                    </span>
                                        <span style={{ borderRadius: '5px', position: 'absolute', left: '0px', top: '0px', padding: '10px', margin: '5px', background: 'linear-gradient(red,#ad1313)', boxShadow: 'pink 1px 1px 10px', fontWeight: 'normal', color: 'white' }}> {p.discountPercent}%</span>
                                  
                                        <br /> <span style={{ margin: '5px' }}>
                                             {fmtPrice(p.price - p.discount)}
                                        </span>
                                    </span>}
                                </div>

                                <div className="mt-auto d-grid gap-2">
                                    {props.anymos == undefined && < Link to={"/Admin/ShowProduct/" + p.productId} type="button" className="btn btn-outline-primary btn-sm">
                                        جزییات بیشتر
                                    </Link>}
                                    {props.anymos != undefined && < Link to={"/ShowProduct/" + p.productId} type="button" className="btn btn-outline-primary btn-sm">
                                        جزییات بیشتر
                                    </Link>}
                                    {p.haveChild == false && <span > در سبد شما :{p.inCart} <br /> </span> }
                                  


                                {p.canOrder == true && p.haveChild==false &&

                                        <button type="button" onClick={() => { addToCart(p.productId) }} className="btn btn-success btn-sm">
                                            🛒 افزودن به سبد خرید
                                        </button>
                                }
                                    {p.canOrder == true && p.haveChild == true &&
                                        <Link to={ (props.anymos == undefined?"/Admin":"") + "/ShowProduct/" + p.productId} >
                                    <button type="button"   className="btn btn-success btn-sm">
                                        🛒 افزودن به سبد خرید
                                        </button>
                                    </Link>
                                }
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
                {pageItems.length === 0 && (
                    <div className="col-12 text-center text-muted py-5">
                        هیچ محصولی یافت نشد 😕
                    </div>
                )}
            </div>

            {/* ===== صفحه‌بندی ===== */}
            {totalPages >= 1 && (
                <nav className="mt-4" dir="ltr">
                    <ul className="pagination justify-content-center">
                        <li className={`page-item ${page === 1 && 'disabled'}`}>
                            <button type="button" style={{ borderRadius: '0px' }} className="page-link" onClick={() => setPage(p => {
                                Math.max(1, p - 1);
                                getLoad(Math.max(1, p - 1));
                            })}>«</button>
                        </li>
                        {Array.from({ length: totalPages }, (_, i) => i + 1).map(n => (
                            <li key={n} className={`page-item ${page === n && 'active'}`}>
                                <button type="button" className="page-link" onClick={() => { setPage(n); getLoad(n); }}>{n}</button>
                            </li>
                        ))}
                        <li className={`page-item ${page === totalPages && 'disabled'}`}>
                            <button type="button" style={{ borderRadius:'0px' }} className="page-link" onClick={() => {
                                setPage(p => {
                                    Math.min(totalPages, p + 1);
                                    getLoad(Math.min(totalPages, p + 1));
                                });
                              
                            }}>»</button>
                        </li>
                    </ul>
                </nav>
            )}
        </form>
    );
};

export default ProductList;


 
// فرض می‌کنیم useParams, useState, LoadingBar, FromBasic, FormDiv و Helper قبلاً ایمپورت شده‌اند

export function ShowProduct(props) {
    const id = useParams().id;
    const [pageState, loadState] = useState({ loaded: false, product: null });

    // استیت‌های جدید برای گالری تصاویر
    const [selectedImage, setSelectedImage] = useState(null);
    const [hoveredIndex, setHoveredIndex] = useState(null);

    const fmtPrice = n => n.toLocaleString('fa-IR') + ' ریال';

    const load = () => {
        let h = new Helper();
        h.Ajax('ClientHub', 'GetProduct', { id: id }, (data) => {
            loadState({ loaded: true, product: data });
        });
    };

    const addToCart = (productId) => {
        if (props.anymos !== undefined) {
            window.location = "/Admin/Shop";
            return;
        }
        let grant = false;
        if ($('#txtGrant').length !== 0) {
            grant = $('#txtGrant')[0].checked;
        }

        let h = new Helper();
        h.Ajax('ClientHub', 'AddToCartGrantySelected', { productId: productId, needGranty: grant }, (data) => {
            h.Alert(data.message);
            load();
        });
    };

    if (pageState.loaded === false) {
        load();
        return <LoadingBar />;
    }

    let product = pageState.product.items[0];

    // آماده‌سازی آرایه تصاویر گالری (تصویر کاور به همراه گالری تصاویر در صورت وجود)
    const galleryImages = product.imageUrls;
    const allImages = [product.imageUrl, ...galleryImages].filter(Boolean);

    return (
        <FromBasic>
            {/* بخش گالری تصاویر به صورت کاشی و قطاری */}
            <FormDiv size="50%">
                   <center>
                        <img src={product.imageUrl} style={{ width: '60%'  }}></img>
                      </center>
                  </FormDiv>

            {/* بخش اطلاعات محصول */}
            <FormDiv size="50%">
                <h4 style={{ color: 'black' }}> نام محصول: {product.productName} </h4>
                گارانتی: {product.haveGranty === true && <span style={{ borderRadius: '5px', marginTop: '25px', background: 'linear-gradient(gold,#a1a704)', fontWeight: 'normal', boxShadow: '#ffd7004a 1px 1px 5px', color: 'white', padding: '2px 8px' }}>12 ماه ضمانت </span>}
                {product.haveGranty === false && <span>فاقد گارانتی</span>}
                <br />

                قیمت: {product.discount === 0 && <span> {fmtPrice(product.price)} </span>}
                {product.discount !== 0 && <span><span style={{ textDecoration: 'line-through', color: 'black' }}> {fmtPrice(product.price)}</span>
                    <br /> قیمت برای شما: <span style={{ borderRadius: '5px', margin: '5px', background: 'linear-gradient(red,#ad1313)', boxShadow: 'pink 1px 1px 10px', fontWeight: 'normal', color: 'white', padding: '2px 6px' }}> {product.discountPercent}%</span>
                    <span style={{ margin: '5px' }}>
                        {fmtPrice(product.price - product.discount)}
                    </span>
                </span>}
                <br />
                {product.haveGranty === true &&
                    <span> <input type="checkbox" id="txtGrant" defaultChecked /> ضمانت 12 ماه </span>
                }
                <br />
                {product.haveChild === false && <span> موجود در سبد شما: {product.inCart}<br /></span>}

                <FormDiv size="100%">
                    {product.descr}
                </FormDiv>

                {product.canOrder === true && product.haveChild === false &&
                    <button type="button" onClick={() => { addToCart(id); }} className="btn btn-success btn-sm">
                        🛒 افزودن به سبد خرید
                    </button>
                }
                {product.canOrder === true && product.haveChild === true &&
                    <span>
                        <table>
                            <tbody>
                                {product.subProducts.map((q) => (
                                    <tr key={q.id}>
                                        <td>{q.productName}</td>
                                        <td>{fmtPrice(q.price)}</td>
                                        <td>
                                            {q.viewStatus === 2 && <button type="button" onClick={() => { addToCart(q.id); }} className="btn btn-success btn-sm">
                                                🛒 افزودن به سبد خرید
                                            </button>}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <br />
                    </span>
                }
                <h5 style={{ color: 'black' }}>نوع محصول: {product.cateGroyName} </h5>
            </FormDiv>
            <FormDiv size="100%">
                <div style={{ padding: '15px' }}>
                    <h6 style={{ color: '#666', marginBottom: '15px' }}>گالری تصاویر محصول:</h6>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
                        gap: '12px',
                        direction: 'rtl'
                    }}>
                        {allImages.map((imgUrl, index) => (
                            <div
                                key={index}
                                style={{
                                    position: 'relative',
                                    aspectRatio: '1/1',
                                    cursor: 'pointer',
                                    overflow: 'hidden',
                                    borderRadius: '12px',
                                    border: hoveredIndex === index ? '2px solid #a855f7' : '1px solid #ddd',
                                    boxShadow: hoveredIndex === index ? '0 0 10px rgba(168, 85, 247, 0.4)' : 'none',
                                    transition: 'all 0.3s ease',
                                }}
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                                onClick={() => setSelectedImage(imgUrl)}
                            >
                                <img
                                    src={imgUrl}
                                    alt={`${product.productName}-${index}`}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        transition: 'transform 0.4s ease',
                                        transform: hoveredIndex === index ? 'scale(1.08)' : 'scale(1)'
                                    }}
                                />
                                {/* لایه هاور با آیکون ذره‌بین */}
                                <div style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    opacity: hoveredIndex === index ? 1 : 0,
                                    transition: 'opacity 0.3s ease',
                                    fontSize: '1.2rem'
                                }}>
                                    <span>🔍</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </FormDiv>
            {/* بخش توضیحات طولانی */}
            <FormDiv size="100%">
                <span dangerouslySetInnerHTML={{ __html: product.longDescr }}></span>
            </FormDiv>

            {/* کامپوننت مدال لایت‌باکس تصاویر */}
            {selectedImage && (
                <div
                    onClick={(e) => e.target.id === 'img-modal-overlay' && setSelectedImage(null)}
                    id="img-modal-overlay"
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999,
                        backdropFilter: 'blur(4px)'
                    }}
                >
                    <div style={{
                        position: 'relative',
                        backgroundColor: '#fff',
                        padding: '25px',
                        borderRadius: '16px',
                        maxWidth: '85%',
                        maxHeight: '85%',
                        boxShadow: '0 0 25px rgba(168, 85, 247, 0.5)',
                        textAlign: 'center'
                    }}>
                        {/* دکمه بستن */}
                        <button
                            onClick={() => setSelectedImage(null)}
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                background: '#f43f5e',
                                color: 'white',
                                border: 'none',
                                borderRadius: '50%',
                                width: '28px',
                                height: '28px',
                                cursor: 'pointer',
                                fontWeight: 'bold'
                            }}
                        >✕</button>

                        <p style={{ fontSize: '12px', color: '#666', marginBottom: '10px' }}>
                            برای مشاهده تصویر اصلی در تب جدید، روی عکس کلیک کنید 🚀
                        </p>

                        {/* باز شدن در تب جدید با تگ A */}
                        <a href={selectedImage} target="_blank" rel="noreferrer">
                            <img
                                src={selectedImage}
                                alt="Full View"
                                style={{
                                    maxHeight: '70vh',
                                    maxWidth: '100%',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    border: '1px solid #eee'
                                }}
                            />
                        </a>
                    </div>
                </div>
            )}
        </FromBasic>
    );
}



////export function ShowProduct(props) {
////    const id = useParams().id;
////    const [pageState, loadState] = useState({ loaded: false, product: null });
////    const fmtPrice = n => n.toLocaleString('fa-IR') + ' ریال';
////    const load = () => {
////        let h = new Helper();
////        h.Ajax('ClientHub', 'GetProduct', { id: id }, (data) => {
////            loadState({ loaded: true, product:data });
////        });

////    };
  
////    const addToCart = (productId) => {
////        if (props.anymos != undefined) {
////            window.location = "/Admin/Shop";
////        }
////        let grant = false;
////        if ($('#txtGrant').length != 0) {
////            grant = $('#txtGrant')[0].checked;
////        }
        

////        let h = new Helper();
////        h.Ajax('ClientHub', 'AddToCartGrantySelected', { productId: productId, needGranty: grant }, (data) => {
////            h.Alert(data.message);
////            load();
////        });
////    }


////    if (pageState.loaded == false) {

////        load();
       
////        return <LoadingBar />
////    }
////    let product = pageState.product.items[0];
    
////    return <FromBasic>
////        <FormDiv size="50%">
////         <center>
////             <img src={product.imageUrl} style={{ width: '60%'  }}></img> 
////            </center>
////        </FormDiv>
////        <FormDiv size="50%">
        
////            <h4 style={{ color: 'black' }}> نام محصول: {product.productName} </h4>
////            گارانتی: {product.haveGranty == true && <span style={{ borderRadius: '5px',   marginTop: '25px', background: 'linear-gradient(gold,#a1a704)', fontWeight: 'normal', boxShadow: '#ffd7004a 1px 1px 5px', color: 'white' }}>12 ماه ضمانت </span>}
////            {product.haveGranty == false &&  <span>فاقد گارانتی</span>}
////            <br />
       
////            قیمت :{product.discount == 0 && <span> {fmtPrice(product.price)} </span>}
////            {product.discount != 0 && <span><span style={{ textDecoration: 'line-through', color: 'black' }}> {fmtPrice(product.price)}

////            </span>
////                <br />   قیمت برای شما : <span style={{ borderRadius: '5px',     margin: '5px', background: 'linear-gradient(red,#ad1313)', boxShadow: 'pink 1px 1px 10px', fontWeight: 'normal', color: 'white' }}> {product.discountPercent}%</span>

////                 <span style={{ margin: '5px' }}>
////                    {fmtPrice(product.price - product.discount)}
////                </span>
////            </span>}
////            <br />
////            {product.haveGranty == true &&
////                <span> <input type="checkbox" id="txtGrant" defaultChecked />ضمانت 12 ماه  </span>  
////            }
////            <br />
////            {product.haveChild==false && <span> موجود در سبد شما : {product.inCart}<br /></span>
////            }
////            <FormDiv size="100%">
////                {product.descr}
////            </FormDiv>


////            {product.canOrder == true && product.haveChild == false  &&
////                <button type="button" onClick={() => { addToCart(id); }} className="btn btn-success btn-sm">
////                    🛒 افزودن به سبد خرید
////                </button>
////            }
////            {product.canOrder == true && product.haveChild == true &&
////                <span>
////                    <table>
////                        {product.subProducts.map((q) => {
////                            return <tr>
////                                <td>{q.productName}</td>
////                                <td>{fmtPrice(q.price)}</td>
////                                <td>
////                                    {q.viewStatus == 2 && <button type="button" onClick={() => { addToCart(q.id); }} className="btn btn-success btn-sm">
////                                        🛒 افزودن به سبد خرید
////                                    </button>
////                                    }

////                                </td>
////                            </tr>

////                        })}
////                    </table>

////                <br/>
////                </span>
////            }
////            <h5 style={{ color: 'black' }}>نوع محصول: {product.cateGroyName} </h5>
////        </FormDiv>
////        <FormDiv size="100%">
////            <span dangerouslySetInnerHTML={{ __html: product.longDescr }}></span>

////        </FormDiv>


////    </FromBasic>

////}

const MyCart = () => {
    const [search, setSearch] = useState('');
    const [category, setCategory] = useState('');
    const [order, setOrder] = useState('newest');
    const [page, setPage] = useState(1);
    const [item, setItem] = useState({ products: [], totalCount: 0 });
    const [categroy, setCateGory] = useState({ categroys: [] });
    const [fristLoad, fristLoadState] = useState({ loaded: false });
    const [delMethodInfo, setdelMethodInfo] = useState({ data:null });
    // فعال‌سازی Select2 روی select دسته‌بندی
    useEffect(() => {
        $('#categorySelect').select2({
            placeholder: 'انتخاب دسته‌بندی…',
            allowClear: false,
            dir: 'rtl',
        }).on('change', (e) => {
            getLoad(1);
        });
        return () => $('#categorySelect').select2('destroy');
    }, []);

    // فیلتر + مرتب‌سازی
    const filtered = item.products;

    const totalPages = Math.ceil(item.totalCount / 8);
    const pageItems = item.products;

    // ----- فرمت قیمت -----
    const fmtPrice = n => n.toLocaleString('fa-IR') + ' ریال';

    const getLoad = (currentPage) => {
        let h = new Helper();
        var data = h.GetPostData();
        data.currentPage = currentPage;
        h.Ajax('ClientHub', 'MyCart', data, (result) => {
            setItem({ products: result.items, totalCount: result.totalRecords });
            setPage(currentPage);
           
        });


    }
    const addToCartAuto = (productId) => {
        let h = new Helper();
        h.Ajax('ClientHub', 'AddToCartAutoBatch', { productId: productId }, (data) => {
            h.Alert(data.message);
            getLoad();
        });
    }
    if (fristLoad.loaded == false) {
        getLoad(1);

        fristLoadState({ loaded: true });
        if (sessionStorage.productId != undefined) {
            addToCartAuto(sessionStorage.productId);
            sessionStorage.clear();
        }

    }
    const addToCart = (productId,needGranty) => {
        let h = new Helper();
        h.Ajax('ClientHub', 'AddToCartGrantySelected', { productId: productId, needGranty: needGranty }, (data) => {
            h.Alert(data.message);
            getLoad();
        });
    }
   
    const removeCart = (productId, needGranty) => {
        let h = new Helper();
        h.Ajax('ClientHub', 'RemoveToCartGrantySelected', { productId: productId, needGranty: needGranty }, (data) => {
            h.Alert(data.message);
            getLoad();
        });
    }



    const clearCart = () => {
        let h = new Helper();
        h.Ajax('ClientHub', 'ClearCart', {}, (data) => {
            h.Alert(data.message);
            getLoad();
        });
    }
    const CreateOrder = () => {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        h.Ajax('ClientHub', 'CreateOrder', h.GetPostData(), (data) => {
            h.Alert(data.message);
            if (data.refId != undefined) {
                window.open("/sf/" + data.refId);
            }
            getLoad();
        });
    }


    return (
        <form className="container-fluid py-4" dir="rtl">
            <center>
                <DropDownBox caption="روش تحویل" onChange={(v) => {
                    let h = new Helper();
                    h.Ajax('ClientHub', 'GetDelMehtod', { id: v.target.value },
                        (result) => {
                            setdelMethodInfo({ data: result });
                        });
                }} entity="DevMethod" size="100%" mustFill="yes" columnName="DevMethodId" />
                <br />
                {delMethodInfo.data != null && <span>{delMethodInfo.data.description} هزینه {fmtPrice(delMethodInfo.data.cost)}<br/></span>}
                <SimpleButton onClick={() => { CreateOrder(); }} title="صدور فاکتور"></SimpleButton>
                <SimpleButton onClick={() => { clearCart(); }} title="پاکسازی سبد خرید"></SimpleButton>
                
            </center>
            
            {/* ===== ردیف محصولات: هر ردیف ۴ تا ===== */}
            <div className="row g-3">
                {pageItems.map(p => (
                    <div className="col-sm-6 col-lg-3" key={p.id}>
                        <div className="card h-100 shadow-sm border-0 product-card">
                            <img
                                src={'/thm/product_' + (p.rootId == null ? p.productId : p.rootId) + ".jpg"}
                                className="card-img-top"
                                alt={p.title}
                                style={{ objectFit: 'contain', height: 180 }}
                            />
                            <div className="card-body d-flex flex-column">
                                <h6 className="card-title text-truncate mb-2">{p.productName}</h6>
                                <p className="text-muted small mb-1">{p.cateGroyName}</p>
                                <div className="fw-bold text-primary mb-3">
                                    {p.haveGranty == true && <span style={{ borderRadius: '5px', position: 'absolute', right: '0px', top: '0px', padding: '10px', margin: '5px', background: 'linear-gradient(gold,#a1a704)', fontWeight: 'normal', boxShadow: '#ffd7004a 1px 1px 5px', color: 'white' }}>12 ماه ضمانت</span>}


                                    <span> {fmtPrice(p.price)} </span>
                                   
                                </div>

                                <div className="mt-auto d-grid gap-2">

                                    <Link to={"/Admin/ShowProduct/" + (p.rootId == null ? p.productId : p.rootId)} type="button" className="btn btn-outline-primary btn-sm">
                                            جزییات بیشتر
                                        </Link>
                                    
                                  


                                      
                                    در سبد شما :{p.inCart}
                                    <center>
                                    <span className="btn btn-success" onClick={() => { addToCart(p.productId, p.haveGranty) }}>+</span>
                                    <span className="btn btn-warning" onClick={() => { removeCart(p.productId, p.haveGranty) }}>-</span>
                                    </center>
                                        <br />
                                   

                                    
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
                {pageItems.length === 0 && (
                    <div className="col-12 text-center text-muted py-5">
                        هیچ محصولی یافت نشد 😕
                    </div>
                )}
            </div>

            {/* ===== صفحه‌بندی ===== */}
            {totalPages >= 1 && (
                <nav className="mt-4" dir="ltr">
                    <ul className="pagination justify-content-center">
                        <li className={`page-item ${page === 1 && 'disabled'}`}>
                            <button type="button" style={{ borderRadius: '0px' }} className="page-link" onClick={() => setPage(p => {
                                Math.max(1, p - 1);
                                getLoad(Math.max(1, p - 1));
                            })}>«</button>
                        </li>
                        {Array.from({ length: totalPages }, (_, i) => i + 1).map(n => (
                            <li key={n} className={`page-item ${page === n && 'active'}`}>
                                <button type="button" className="page-link" onClick={() => { setPage(n); getLoad(n); }}>{n}</button>
                            </li>
                        ))}
                        <li className={`page-item ${page === totalPages && 'disabled'}`}>
                            <button type="button" style={{ borderRadius: '0px' }} className="page-link" onClick={() => {
                                setPage(p => {
                                    Math.min(totalPages, p + 1);
                                    getLoad(Math.min(totalPages, p + 1));
                                });

                            }}>»</button>
                        </li>
                    </ul>
                </nav>
            )}
        </form>
    );
};


export class MyLoans extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });

        this.Refersh = this.Refersh.bind(this);

    }



    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('ClientHub', 'MyLoan', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }
  
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <AddButton title='' entity='LoanInComingDateResult' /> <ProTable Records={this.state.Records} datasourcename='LoanInComingDateResults'>
                    <Column metaForDisplay={DataClass.LoanInComingDateResult.id} />
                    
                    <Column metaForDisplay={DataClass.LoanInComingDateResult.OrderId} />
                     
                    <Column metaForDisplay={DataClass.LoanInComingDateResult.InComingDate} />
                    <Column metaForDisplay={DataClass.LoanInComingDateResult.PayStatus} />
                    <Column metaForDisplay={DataClass.LoanInComingDateResult.Price} />
                    <Action caption="نمایش فاکتور" type="function" targetFun={(r) => {
                        window.open("/sf/" + r.orderId);
                    }} />
                    <Action caption="پرداخت" type="function" showCond={(r) => { return r.payStatus ==0 } } targetFun={(r) => {
                        window.open("/pl/" + r.id);
                    }} />




                </ProTable>
            </FromBasic>
        }
    }



}

export function MyUsagedAccounts(props) {

    const [pageState, loadState] = useState({ records: [] ,isLoaded:false});

    const serach = () => {
        let h = new Helper();
        let d = h.GetPostData();
        h.Ajax('ClientHub', 'MyGamingAccounts', d, (data) => {
            loadState({ records: data, isLoaded:true });
        });

    };
    if (pageState.isLoaded == false) {

        serach();
        return <LoadingBar />;
    }
 



    return <FromBasic static="اکانت های در اختیار من">

    
    
        <ProTable Records={pageState.records} datasourcename='UsageAccs'>
            <Column type={ColumnType.Image} caption="تصویر" columnName="gameId" url="/images/cover/" ext=".jpg" />
            <Column type={ColumnType.DisplayValue} caption="نام بازی" columnName="gameTitle" />
            <Column type={ColumnType.DisplayValue} caption="اکانت" columnName="email" />
            <Column metaForDisplay={DataClass.UsageAcc.usageType} />
            <Column metaForDisplay={DataClass.UsageAcc.delvere} />
            <Column metaForDisplay={DataClass.UsageAcc.descr} />
        

        </ProTable>
        <ShowFixedPage id={"قوانین ظرفیت ها"} />
    </FromBasic>
}

class UploadID extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { image: '/Icons/Doctor.png' };
        this.save = this.save.bind(this);
    }
    save() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        let formData = new FormData();
        let cx = document.getElementById('txtfil')
        formData.append('file', cx.files[0], cx.value);
        if (h.isValidate() == true) {
            h.AjaxForUpload('ClientHub', 'UploadId', formData, function (data) {
                h.MessageBox(data.message, '');
                if (data.status == '200') {
                    h.GoBack();
                }
            });
        }
    }
    componentDidMount() {
        let h = new Helper();
        let cmd = this;
        h.Ajax('ClientHub', 'GetIdPaper', {},
            function (data) {
                cmd.setState({ image: data.imgSrc });
            });
    }


    render() {
        return <FromSubmit submitBev={this.save}>
            <FormDiv size='100%' >
                تصویر فعلی <br></br>
                <img alt="تصویری ارسال نشده است" style={{ maxWidth:'100%' }} src={this.state.image + '?qid=' + Math.random().toString()}></img>
                <InputTextBox columnName='fil' caption='فایل' mustFill='yes' model='file' size='100%' customHelper={CustomHelper.File} ></InputTextBox>
            </FormDiv>

        </FromSubmit>
    }
}


export class Regit extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            level: 0, planId: 0, conso: 0, plans: [], game: [], prices: [], selectedPrice: {}, priceIndex: -1
        };

    }
    componentDidMount() {
        this.loadData();
    }
    loadData() {
        let s = this.state;
        let h = new Helper();
        let cmd = this;
        h = h.Ajax('Home', 'AllPlan', {}, (data) => {
            s.plans = data;
            cmd.setState(s);

        });
    }
    loadGames() {
        let s = this.state;
        let h = new Helper();
        let cmd = this;
        h = h.Ajax('Home', 'AllGameOfPlan', { id: this.state.planId }, (data) => {
            s.game = data;
            cmd.setState(s);

        });
    }
    loadPrice() {
        let s = this.state;
        let h = new Helper();
        let cmd = this;
        h = h.Ajax('Home', 'AllPriceOfPlan', { planTitle: '', planId: this.state.planId, console: this.state.conso }, (data) => {
            s.prices = data;
            cmd.setState(s);

        });
    }
    selectConsole(conType) {
        let s = this.state;
        s.level += 1;
        s.conso = conType;
        this.setState(s);
    }
    reg() {
        let h = new Helper();
        h.Validate();
        if (this.state.selectedPrice == null) {
            h.errors.push("لطفا یک گزینه برای طرح انتخاب کنید");
        }
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetPostData();
        var keys = Object.keys(this.state.selectedPrice);
        for (var l = 0; l < keys.length; l++) {
            data[keys[l]] = this.state.selectedPrice[keys[l]];
        }
        let cmd = this;
        let paymethod = data.payMethod;
        h.Ajax('ClientHub', 'RegGameSub', data, (data) => {
            if (data.status == '200') {
                h.Alert(data.message);
                let s = cmd.state;
                if (paymethod == '2') {
                    window.open("/sp/" + data.refId);
                }
                s.level = 3;
                cmd.setState(s);
            }
            else {
                h.Error(data.message);
            }
        });
    }
    render() {
        let h = new Helper();
        return <FromBasic staticTitle='ثبت نام' >



            {this.state.level == 0 &&
                <span>

                    لطفا نوع دستگاه خود را انتخاب کنید <br />
                    <button className="col-sm-12 btn" type="button" onClick={() => { this.selectConsole(0); }} style={{ border: '1px solid ', borderRadius: '5px' }}>
                        <img src="/images/ps4.jpg" height="80px"></img>
                        <br />
                        پلی استیشن 4
                    </button>
                    <button className="col-sm-12  btn" type="button" onClick={() => { this.selectConsole(1); }} style={{ border: '1px solid ', borderRadius: '5px' }}>
                        <img src="/images/ps5.jpg" height="80px"></img>
                        <br />
                        پلی استیشن 5
                    </button>
                </span>
            }
            {this.state.level == 1 &&
                <span>

                    لطفا نوع طرح را انتخاب کنید <br />

                    <br />
                    {this.state.plans.map((v) => {
                        return <span> <SimpleButton Icon={v.id == this.state.planId ? "Yes" : undefined} title={v.title} onClick={() => {
                            let s = this.state;
                            s.planId = v.id;
                            s.planTitle = v.title;
                            this.setState(s);
                            this.loadGames();
                        }}  ></SimpleButton>
                            <br />
                        </span>

                    })}


                    <center>
                        <button className="btn btn-light" type="button" onClick={() => { if (this.state.planId <= 0) { h.Alert("لطفا یک طرح انتخاب کنید"); } let s = this.state; s.level = 2; this.setState(s); this.loadPrice(); }}>
                            ادامه
                        </button>
                        <button className="btn btn-light" type="button" onClick={() => { let s = this.state; s.level = 0; this.setState(s); }}>
                            بازگشت
                        </button>
                        <FromBasic>
                            {this.state.game.map((v) => {
                                return <div className="col-sm-6">
                                    {v.title} <br />
                                    <img width="80px" src={"/images/cover/" + v.id + ".jpg"} ></img>

                                </div>
                            })}
                        </FromBasic>
                    </center>
                </span>
            }
            {this.state.level == 2 &&
                <span style={{ textAlign: 'right' }}>

                    لطفا مشخصات زیر پر کنید <br />

                    <br />
                    نوع دستگاه : {h.GetCaptionFromEnum(enums.GameType, this.state.conso)} طرح انتخابی : {this.state.planTitle}
                    <br />
                    {this.state.prices.map((v) => {
                        return <span> <SimpleButton Icon={v == this.state.selectedPrice ? "Yes" : undefined} title={h.GetCaptionFromEnum(enums.TimeDurrion, v.timeDurrion) + " تعداد بازی همزمان  " + v.gameCount} onClick={() => {
                            let s = this.state;
                            s.selectedPrice = v;
                            this.setState(s);
                        }}  ></SimpleButton>
                            <br />
                        </span>
                    })}

                      <InputBox meta={DataClass.Reg.payMethod} size="100%" />
               
                    <h2>
                        مبلغ قابل پرداخت: {h.addCommas(this.state.selectedPrice.price)} ریال</h2> <br />
                    شماره کارت جهت پرداخت :6104337961803788 علی حسینی پور
                    <center>
                        <button className="btn btn-light" type="button" onClick={() => { this.reg() }}>
                            ثبت نام
                        </button>
                        <button className="btn btn-light" type="button" onClick={() => { let s = this.state; s.level = 0; this.setState(s); }}>
                            بازگشت
                        </button>

                    </center>
                </span>
            }
            {this.state.level == 3 &&
                <span>
                    ثبت نام شما با موفقیت انجام شد جهت ادامه به فروشگاه مراجعه کنید
                    <br />
                    <Link to="/Login">
                        بازگشت

                    </Link>


                </span>
            }
        </FromBasic>;
                
    }
}





export function ClientHubApp(props) {

    let routes = [
        <Route path="MyMessages" element={<SmsReportForMe />} />,
        <Route path="MyOrders" element={<MyOrders />} />,
        <Route path="MyCart" element={<MyCart />} />,
        <Route path="SendId" element={<UploadID />} />,
        <Route path="RegGameSub" element={<Regit />} />,
        <Route path="MyAccounts" element={<MyUsagedAccounts />} />,
        <Route path="Shop" element={<ProductList />} />,
        <Route path="ShowProduct/:id" element={<ShowProduct />} />,
        <Route path="Profile" element={<Profile />} />,
        <Route path="MyLoans" element={<MyLoans />} />,
        <Route path="MyTransactions" element={<MyTransactions />} />,
        <Route path="GrantyStatus" element={<SerailBySerail />} />,
    ];
    return routes;
}